import React from 'react';
import { Text } from '@make-software/tg-mini-app-ui';

import { Platform } from '@/shared';

import {
  Steps,
  StepRow,
  StepIndex,
  StepText,
  Section,
  Hint
} from './install-to-home-screen.styled';

interface StepsSectionProps {
  platform: Platform;
  showOpenInBrowserStep: boolean;
}

export const StepsSection: React.FC<StepsSectionProps> = ({ platform, showOpenInBrowserStep }) => {
  return (
    <>
      {showOpenInBrowserStep && (
        <Section>
          <Text weight={1} size="sm" color="white">
            Open TEA in browser
          </Text>
          <Hint>
            {platform === 'ios' ? (
              <>
                Telegram may block installation inside the app. Use <b>Open in browser</b>. If it
                doesn’t work, use <b>Copy link</b> and open it manually in <b>Safari</b>.
              </>
            ) : (
              <>
                Telegram may block installation inside the app. Use <b>Open in browser</b>. If it
                doesn’t work, use <b>Copy link</b> and open it manually in Safari/Chrome.
              </>
            )}
          </Hint>
        </Section>
      )}

      <Section>
        <Text weight={1} size="sm" color="white">
          {platform === 'ios' ? 'iOS' : 'Android'} install
        </Text>

        <Steps>
          {platform === 'android' ? (
            <>
              <StepRow>
                <StepIndex>1</StepIndex>
                <StepText>In Chrome tap ⋮</StepText>
              </StepRow>
              <StepRow>
                <StepIndex>2</StepIndex>
                <StepText>Select “Add to Home screen”</StepText>
              </StepRow>
            </>
          ) : (
            <>
              <StepRow>
                <StepIndex>1</StepIndex>
                <StepText>Share → “Add to Home Screen”</StepText>
              </StepRow>
            </>
          )}

          <StepRow>
            <StepIndex>{platform === 'ios' ? 2 : 3}</StepIndex>
            <StepText>Open TEA from the new icon</StepText>
          </StepRow>

          <StepRow>
            <StepIndex>{platform === 'ios' ? 3 : 4}</StepIndex>
            <StepText>Enter the verification code in the installed app</StepText>
          </StepRow>
        </Steps>

        {platform === 'ios' && (
          <Hint>
            Important: when launching TEA from the Home Screen icon, keep it opening as a{' '}
            <b>Web App</b>
            (don’t disable “Open as Web App” on iOS).
          </Hint>
        )}
      </Section>

      <Section>
        <Text weight={1} size="sm" color="white">
          Verification
        </Text>
        <Hint>
          After you open TEA from the home screen icon, you’ll see an OTP screen. Enter the code
          there to link the installed app and unlock claiming the reward.
        </Hint>
      </Section>
    </>
  );
};
